import { useEffect, useState } from 'react';

import { useApiFacade } from './use-api-facade';
import { CompanyResponse } from '../services/company.services';

interface Props {
	id: number;
	refresh?: number;
	enabled?: boolean;
}

type UseGetCompanyById = [
	CompanyResponse | undefined,
	Error | undefined,
	boolean,
];

export const useGetCompanyById = ({
	id,
	refresh = 0,
	enabled = true,
}: Props): UseGetCompanyById => {
	const facade = useApiFacade();
	const [data, setData] = useState<CompanyResponse | undefined>(undefined);
	const [error, setError] = useState<Error | undefined>(undefined);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		let cancelled = false;

		if (!enabled || !id) {
			setIsLoading(false);
			return;
		}

		setIsLoading(true);
		setError(undefined);

		facade.client
			.get(`/v1/admin/companies/${id}`, {})
			.then((response) => {
				if (cancelled) return;
				setData(response.data);
				setIsLoading(false);
			})
			.catch((err) => {
				if (cancelled) return;
				setError(err);
				setIsLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [facade, refresh, id, enabled]);

	return [data, error, isLoading];
};
